import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.array.push.js";
import lottieWeb from 'lottie-web';
import { mapState } from 'vuex';
import { handleLocalStorage, FormatTime } from '@/assets/js/utils.js';
export default {
  props: {
    summaryLanguage: {
      type: String,
      default: ''
    },
    behaviorInfo: {
      type: Object,
      default: () => {}
    },
    userInfo: {
      type: Object,
      default: () => {}
    },
    partyCode: {
      type: [String, Number],
      default: ''
    },
    rtilCodeKeyTypeVal: {
      type: Object,
      default: () => {}
    },
    sttRtilCode: {
      type: [String, Number],
      default: ''
    },
    showAISpeech: {
      type: Boolean,
      default: false
    },
    sttHistoryList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      demo: '',
      needDirectScrollToBottom: false,
      hasScrollbar: false,
      dividerNewLineDistance: false,
      showDivider: false,
      showTranslate: false,
      showScrollTopBtn: false,
      voiceContent: [],
      showSetting: false,
      aiJson: require('@/assets/json/AIRobot.json'),
      translateInto: '',
      langArray: [{
        label: 'Disable Translation',
        val: ''
      }, {
        label: 'English',
        val: 'English'
      }, {
        label: 'Chinese Simplified',
        val: '中文简体'
      }, {
        label: 'Chinese Traditional',
        val: '中文繁體'
      }, {
        label: 'Korean',
        val: 'Korean'
      }, {
        label: 'Japanese',
        val: 'Japanese'
      }, {
        label: 'Spanish',
        val: 'Spanish'
      }, {
        label: 'Portugues',
        val: 'Portugues'
      }, {
        label: 'French',
        val: 'French'
      }],
      scourceTypeVal: ['Manwindow', 'Web', 'Anywhere', 'R', 'T', 'App', 'MH'],
      sourceTypeArray: [{
        label: 'mainwindow',
        val: 'Manwindow'
      }, {
        label: 'webParticipants',
        val: 'Web'
      }, {
        label: 'tvuAnywhereParticipants',
        val: 'Anywhere'
      }, {
        label: 'tvuAppParticipants',
        val: 'App'
      }, {
        label: 'receiverParticipants',
        val: 'R'
      }, {
        label: 'tvuOneParticipants',
        val: 'T'
      }, {
        label: 'mediaParticipants',
        val: 'MH'
      }],
      isRunning: false,
      isScrolling: false,
      scrollTimer: null,
      summaryLoading: false,
      productionId: '',
      rtilCodeKeyIsFinalVal: {},
      // 用来记录最终句是否完成
      rtilCodeKeyIndexVal: {},
      // 用来记录需要改为最终句的位置
      translateIndexArray: [],
      //  用来记录翻译的索引
      aiBotTimer: null,
      // 用来记录 10s 内没人说话自动关闭 aibot
      twoMinutesTimer: null,
      // 用来记录两分钟后自动关闭 aibot
      sendCommnad: false,
      // AI Speech 显示后的第一句 host 说的话才需要发送
      sendEmailInfo: {
        title: 'common.sendSetting',
        save: 'commonPartyHost.topContent.send',
        hideSave: true,
        show: false
      },
      emailList: [{
        title: 'sendByEmail',
        value: ''
      }, {
        title: 'sendBySlack',
        value: ''
      }],
      showSavingTips: false,
      saveEmailSuccess: false,
      sttKeyNumber: 0 // 用来记录 stt 里面每行的 key 用数字记录保持不变方便添加翻译和内容追加
    };
  },

  watch: {
    translateInto(newVal) {
      handleLocalStorage('set', 'translateInto', newVal);
    },
    'voiceContent.length': {
      handler(newValue, oldValue) {
        if (newValue != oldValue && oldValue) {
          if (newValue > 1) {
            // 必须有至少两个条目才能设置前一个的分割线
            const anyHasDivider = this.voiceContent.some(item => item.showDivider === true);
            if (!anyHasDivider && !this.dividerNewLineDistance && this.hasScrollbar) {
              this.showScrollTopBtn = true;
              this.$set(this.voiceContent[newValue - 2], 'showDivider', true);
            }
          }
        }
      },
      deep: true
    },
    // 是否滚动到底部
    dividerNewLineDistance: {
      handler(neValue) {
        if (!neValue) return;
        this.voiceContent.forEach((val, index) => {
          if (val.showDivider) {
            this.$set(this.voiceContent[index], 'showDivider', false);
            this.showScrollTopBtn = false;
          }
        });
      },
      deep: true
    },
    showAISpeech(val) {
      if (val) {
        this.scrollToBottom();
      }
    }
  },
  computed: {
    ...mapState({
      State: state => state
    }),
    returnSavingEmailText() {
      let _str = this.$t('aiSpeech.emailSaving');
      if (this.showSavingTips && this.saveEmailSuccess) {
        _str = this.$t('aiSpeech.emailSaved');
      }
      return _str;
    }
  },
  mounted() {
    this.getHistoryData();
    this.initAddlisten();
    this.initLottie();
    const savedTranslateInto = handleLocalStorage('get', 'translateInto');
    if (savedTranslateInto) {
      this.translateInto = savedTranslateInto;
    }
  },
  methods: {
    getHistoryData() {
      this.axios.get(`/partyline-backend/stt/transcript/noLogin/q?partyCode=${this.partyCode}`).then(res => {
        if (res.data.errorCode === '0x0') {
          const data = res.data.result;
          if (data && data.length > 0) {
            const array = [];
            data.forEach((item, index) => {
              const decodedBytes = atob(item.text);
              const utf8Decoder = new TextDecoder();
              const originalContent = utf8Decoder.decode(new Uint8Array(decodedBytes.split('').map(char => char.charCodeAt(0))));
              const obj = {
                uid: item.rtilCode,
                content: originalContent,
                time: item.endTime
              };
              if (index == data.length - 1) {
                obj.showDivider = true;
              }
              array.push(obj);
            });
            const showArray = array.slice(-100).map(item => {
              this.sttKeyNumber++;
              return {
                ...item,
                id: this.sttKeyNumber
              };
            });
            this.voiceContent = showArray;
          }
        }
      });
    },
    returnEmailTips(type) {
      if (type === 'sendByEmail') {
        return this.$t('aiSpeech.sendEmailTips') + '<br/>' + this.$t('aiSpeech.sendEmailTips2');
      } else {
        return this.$t('aiSpeech.sendSlackTips');
      }
    },
    handleScroll() {
      const scrollContainer = this.$refs.content;
      // 判断滚动条是否出现
      this.hasScrollbar = scrollContainer.scrollHeight > scrollContainer.clientHeight;
      // Newline显示 什么时候到底部,误差1
      this.dividerNewLineDistance = scrollContainer.scrollTop + scrollContainer.clientHeight + 1 >= scrollContainer.scrollHeight;
      if (!this.dividerNewLineDistance) {
        this.showScrollTopBtn = true;
      } else {
        this.showScrollTopBtn = false;
      }
    },
    scrollToBottom() {
      if (this.needDirectScrollToBottom) {
        // 如果标志位为true，直接滚动到底部
        this.$refs.content.scrollTop = this.$refs.content.scrollHeight;
        this.showScrollTopBtn = false;
        this.needDirectScrollToBottom = false; // 滚动后重置标志
      } else {
        // 找到带有 `showDivider` 的元素
        const lastDividerIndex = this.voiceContent.findIndex((item, index) => {
          return item.showDivider && index < this.voiceContent.length - 1;
        });
        if (lastDividerIndex !== -1) {
          // DOM元素处理，找到对应的消息框的DOM
          const refName = `msgBoxRef${lastDividerIndex}`;
          const msgBoxElement = this.$refs[refName][0];
          if (msgBoxElement) {
            // 计算滚动位置
            const topPos = msgBoxElement.offsetTop;
            this.$refs.content.scrollTop = topPos - this.$refs.content.offsetTop;
            this.needDirectScrollToBottom = true; // 滚动后重置标志
          }
        } else {
          // 如果不存在带 `showDivider` 的元素，直接滚动到底部
          this.$refs.content.scrollTop = this.$refs.content.scrollHeight;
        }
        this.showScrollTopBtn = false;
      }
    },
    initAddlisten() {
      const content = this.$refs.content;
      content.addEventListener('scroll', () => {
        this.isScrolling = content.scrollHeight - content.scrollTop > content.clientHeight;
      });
    },
    initLottie() {
      const animation = lottieWeb.loadAnimation({
        container: document.getElementById('lottie'),
        animationData: this.aiJson,
        loop: true,
        autoplay: true
      });
      animation.play();
    },
    formatTimeToAMPM(timestamp) {
      if (!timestamp) return;
      // 将时间戳转换为Date对象
      const date = new Date(timestamp);

      // 获取小时数（0-23）
      let hour = date.getHours();

      // 获取分钟数
      const minutes = date.getMinutes();

      // 设置 AM 或 PM
      const ampm = hour >= 12 ? 'PM' : 'AM';

      // 将24小时制转换为12小时制
      hour = hour % 12;
      hour = hour == 0 ? 12 : hour; // 将0时转换为12时

      // 格式化分钟使其始终为两位数
      const minutesFormatted = minutes < 10 ? '0' + minutes : minutes;

      // 返回格式化的字符串
      return `${hour}:${minutesFormatted} ${ampm}`;
    },
    showSpeechSetting() {
      this.showSetting = true;
    },
    closeSpeechSetting() {
      this.showSetting = false;
    },
    judegeShowMsg(uid) {
      let showMsg = true;
      if (this.userInfo.rtilCode != uid && (!this.rtilCodeKeyTypeVal[uid] || this.rtilCodeKeyTypeVal[uid] && !this.scourceTypeVal.includes(this.rtilCodeKeyTypeVal[uid]))) showMsg = false;
      return showMsg;
    },
    dealAiSpeechInfo(payload) {
      this.showSpeechContent(payload);
    },
    showSpeechContent(payload) {
      const {
        uid,
        words,
        time
      } = payload.textInfo;
      const showMsg = this.judegeShowMsg(uid);
      if (!showMsg) return;
      const voiceContent = this.voiceContent;
      const contentString = words.filter(item => {
        return item.text !== 'string' && item.text != '.';
      }).map(item => item.text).join(' ');
      const isEnd = this.rtilCodeKeyIsFinalVal[uid]; // 状态分为三种：1. 未结束 2. 结束 3. 还没有数据
      const lastPosition = this.rtilCodeKeyIndexVal[uid];
      const timeStamp = time || new Date().getTime();
      const canSendVoiceCommand = this.State.voiceCommandList.includes(uid) && uid == this.userInfo.rtilCode;
      const data = {
        uid: uid,
        content: contentString,
        time: timeStamp
      };
      // 处理显示 AIBot
      this.dealContentString(contentString, time, canSendVoiceCommand);
      if (time) {
        this.rtilCodeKeyIsFinalVal[uid] = true;
        this.uploadMsg(payload.textInfo, contentString);
        if (lastPosition === undefined) {
          // 只保留 100 条数据
          this.sttKeyNumber++;
          if (voiceContent.length >= 100) {
            voiceContent.shift();
          }
          voiceContent.push({
            ...data,
            id: this.sttKeyNumber
          });
          this.$set(this.rtilCodeKeyIndexVal, uid, this.sttKeyNumber);
        } else {
          voiceContent.forEach(item => {
            if (item.id == lastPosition) item.content = contentString;
          });
        }
        const isSameLanguage = this.detectLanguage(this.translateInto, contentString);
        if (this.translateInto && !isSameLanguage) {
          this.sendTranslate(contentString, lastPosition);
        }
        if (canSendVoiceCommand && this.sendCommnad && this.State.aiBotFeature && this.State.showAIBot) {
          this.isNeedSendCommand(uid, contentString);
        }
      } else {
        this.rtilCodeKeyIsFinalVal[uid] = false;
        if (isEnd) {
          this.sttKeyNumber++;
          if (voiceContent.length >= 100) {
            voiceContent.shift();
          }
          voiceContent.push({
            ...data,
            id: this.sttKeyNumber
          });
          this.$set(this.rtilCodeKeyIndexVal, uid, this.sttKeyNumber);
        } else {
          if (isEnd === undefined) {
            this.sttKeyNumber++;
            if (voiceContent.length >= 100) {
              voiceContent.shift();
            }
            voiceContent.push({
              ...data,
              id: this.sttKeyNumber
            });
            this.$set(this.rtilCodeKeyIndexVal, uid, this.sttKeyNumber);
          } else {
            voiceContent.forEach(item => {
              if (item.id == lastPosition) item.content = contentString;
            });
          }
        }
        // 判断是否为自己说的
        if (this.State.showAIBot) {
          if (this.State.aiBotCommandStatus != 5) {
            this.State.aiBotCommandStatus = 5;
          }
          this.State.currentSpeech = contentString;
          this.sendCommnad = true;
          this.clearAIBotTimer('noSpeak');
        }
      }
      this.dealScroll();
    },
    uploadMsg(msgInfo, content) {
      const {
        uid,
        time
      } = msgInfo;
      const utf8Bytes = new TextEncoder().encode(content);
      const base64Encoded = btoa(String.fromCharCode(...utf8Bytes));
      const params = {
        msgId: time,
        text: base64Encoded,
        rtilCode: uid,
        nickName: this.behaviorInfo[uid],
        endTime: time,
        partyCode: this.userInfo.joinCode
      };
      this.axios.post('/partyline-backend/stt/transcript/noLogin/upload', params).then(res => {});
    },
    dealContentString(contentString, time, canSendVoiceCommand) {
      if (!canSendVoiceCommand) return;
      const text = contentString.toLowerCase();
      if (time && (text.includes('hi ai') || text.includes('hey ai') || text.includes('hei ai') || text.includes('hey ai') || text.includes('准备'))) {
        this.sendCommnad = false;
        this.State.showAIBot = true;
        this.State.aiBotCommandStatus = 0;
        console.log(this.State.aiBotFeature, this.State.aiBotEnable, this.State.showAIBot);
        // 10s 后无人说话关闭, 2分钟后自动关闭
        this.setAIBotTimer('noSpeak', 20 * 1000);
        this.setAIBotTimer('twoMinutes', 2 * 60 * 1000);
      }
    },
    detectLanguage(key, text) {
      const ranges = {
        Chinese: /[\u4e00-\u9fff]/,
        English: /[a-zA-Z]/,
        Korean: /[\uac00-\ud7af]/,
        Japanese: /[\u3040-\u30ff\u31f0-\u31ff\u4e00-\u9fff]/,
        Spanish: /[áéíóúñüÁÉÍÓÚÑÜ]/,
        Portuguese: /[áâãéêíóôõúçÁÂÃÉÊÍÓÔÕÚÇ]/,
        French: /[àâçéèêëîïôûùüÿÀÂÇÉÈÊËÎÏÔÛÙÜŸ]/
      };
      for (const [lang, regex] of Object.entries(ranges)) {
        if (regex.test(text)) {
          if (lang === 'Chinese' && ranges.Japanese.test(text)) {
            // 鉴于中日字符的重叠，对于同时匹配中文和日文的字符串，将进一步判断偏向于哪种语言
            const moreLikelyJapanese = /[\u3040-\u30ff\u31f0-\u31ff]/.test(text);
            return moreLikelyJapanese ? key == 'Japanese' : key == ('中文简体' || '中文繁体');
          } else if (lang == 'Spanish' || lang == 'Portuguese') {
            const spanishIndicators = /(?=.*\b(el|la|los|las|un|una|unos|unas|yo|tú|él|ella|nosotros|vosotros|ellos|ellas)\b).*\w+/i;
            const portugueseIndicators = /(?=.*\b(o|a|os|as|um|uma|uns|umas|eu|tu|ele|ela|nós|vós|eles|elas)\b).*\w+/i;
            if (spanishIndicators.test(str) && !portugueseIndicators.test(str)) {
              return key == 'Spanish';
            } else if (portugueseIndicators.test(str) && !spanishIndicators.test(str)) {
              return key == 'Portuguese';
            } else if (spanishIndicators.test(str) && portugueseIndicators.test(str)) {
              return false;
            }
          }
          return key == lang;
        }
      }
      return false;
    },
    sendTranslate(contentString, key) {
      if (!contentString || !this.translateInto || !key) return;
      const params = {
        id: key,
        text: contentString,
        partyCode: this.partyCode,
        targetLanguage: this.translateInto
      };
      this.axios.post('/partyline-backend/stt/translate/noLogin/t', params).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          this.voiceContent = this.voiceContent.map(item => {
            if (item.id == result.id) {
              return {
                ...item,
                translateContent: result.text,
                showDivider: false
              };
            }
            return item;
          });
          this.dealScroll();
        }
      });
    },
    setAIBotTimer(key, time) {
      const timer = key === 'noSpeak' ? 'aiBotTimer' : 'twoMinutesTimer';
      if (this[timer]) clearTimeout(this[timer]);
      this[timer] = setTimeout(() => {
        if (key === 'noSpeak') {
          this.State.showAIBot = false;
          this.State.aiBotCommandStatus = 0;
          this.State.currentSpeech = '';
        } else {
          // 消息没有处于发送中再去关闭 aibot
          if (this.State.aiBotCommandStatus != 1) {
            this.State.showAIBot = false;
            this.State.aiBotCommandStatus = 0;
            this.State.currentSpeech = '';
          }
        }
      }, time);
    },
    clearAIBotTimer(key) {
      const timer = key === 'noSpeak' ? this.aiBotTimer : this.twoMinutesTimer;
      if (timer) clearTimeout(timer);
    },
    judgeSendCommand(contentString) {
      const text = contentString.toLowerCase();
      let isHaveKey = false;
      let isHavePGMPVW = false;
      if (text.includes('switch') || text.includes('swiss') || text.includes('sweet') || text.includes('cut') || text.includes('card') || text.includes('cart')) {
        isHaveKey = true;
      }
      if (text.includes('pgm') || text.includes('pvm') || text.includes('dvm') || text.includes('pcm') || text.includes('dcm') || text.includes('pvw') || text.includes('pcw') || text.includes('pvw') || text.includes('dcw') || text.includes('dvw') || text.includes('review') || text.includes('preview')) {
        isHavePGMPVW = true;
      }
      if (isHaveKey && isHavePGMPVW) {
        return true;
      } else {
        return false;
      }
    },
    isNeedSendCommand(uid, contentString) {
      // 根据最新需求需要2分钟内持续说话，所以需要判断是否为执行命令
      const executCommand = this.judgeSendCommand(contentString);
      if (!executCommand) return;
      this.sendCommnad = false;
      if (!this.State.productionId) {
        this.State.aiBotCommandStatus = 4;
        return;
      }
      this.State.aiBotCommandStatus = 1;
      const params = {
        productionId: this.State.productionId,
        command: contentString,
        rtilCode: uid
      };
      this.axios.post('/partyline-backend/voiceCommand/noLogin/execute', params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.State.aiBotCommandStatus = 2;
        } else {
          this.State.aiBotCommandStatus = 3;
        }
        this.clearAIBotTimer('twoMinutes');
        this.setAIBotTimer('noSpeak', 20 * 1000);
        this.setAIBotTimer('twoMinutes', 2 * 60 * 1000);
      }).catch(() => {
        this.State.aiBotCommandStatus = 3;
        this.clearAIBotTimer('twoMinutes');
        this.setAIBotTimer('noSpeak', 20 * 1000);
        this.setAIBotTimer('twoMinutes', 2 * 60 * 1000);
      });
    },
    dealScroll() {
      this.$nextTick(() => {
        if (!this.$refs.content) return;
        if (!this.showScrollTopBtn) {
          this.$refs.content.scrollTop = this.$refs.content.scrollHeight;
        }
      });
    },
    createSummary() {
      if (!this.partyCode) return;
      this.summaryLoading = true;
      this.State.summaryInfo.loading = true;
      const msgList = [];
      for (const item of this.voiceContent) {
        if (this.behaviorInfo[item.uid] && item.time) {
          const obj = {
            nickName: this.behaviorInfo[item.uid],
            content: item.content,
            time: item.time
          };
          msgList.push(obj);
        }
      }
      this.State.summaryInfo.show = true;
      this.axios.get(`/partyline-backend/stt/transcript/noLogin/summary/${this.partyCode}`, {
        params: {
          language: this.summaryLanguage
        }
      }, {
        timeout: 120000,
        errorTip: false
      }).then(res => {
        this.summaryLoading = false;
        if (res.data.errorCode === '0x0') {
          this.State.summaryInfo.contentText = res.data.result;
          if (msgList.length > 100) {
            this.State.summaryInfo.startTime = this.formatTimeToAMPM(msgList[msgList.length - 101].time);
            this.State.summaryInfo.endTime = this.formatTimeToAMPM(msgList[msgList.length - 1].time);
          } else if (msgList.length > 0 && msgList.length <= 100) {
            this.State.summaryInfo.startTime = this.formatTimeToAMPM(msgList[0].time);
            this.State.summaryInfo.endTime = this.formatTimeToAMPM(msgList[msgList.length - 1].time);
          }
          this.dealScroll();
        } else if (res.data.errorCode === '82207001') {
          this.$message.warning(this.$t('aiSpeech.noTranscript'));
        }
        this.State.summaryInfo.loading = false;
      }).catch(e => {
        console.log(e);
        this.summaryLoading = false;
        this.State.summaryInfo.loading = false;
        this.$message({
          message: this.$t('aiSpeech.getSummaryFailed'),
          type: 'error'
        });
      });
    },
    copyMessage() {
      if (navigator.clipboard) {
        console.log(this.formatTimeToAMPM(1715053496573));
        console.log(FormatTime(1715053496573));
        const text = this.voiceContent.map(item => `${FormatTime(item.time)} - ${this.behaviorInfo[item.uid]}: ${item.content}`).join('\n');
        navigator.clipboard.writeText(text).then(() => {
          this.$message({
            message: this.$t('aiSpeech.copySuccess'),
            type: 'success'
          });
        }).catch(() => {
          this.$message({
            message: this.$t('aiSpeech.copyFail'),
            type: 'error'
          });
        });
      } else {
        this.$message({
          message: this.$t('aiSpeech.notSupportCopy'),
          type: 'error'
        });
      }
    },
    copySummary(index) {
      if (!this.voiceContent[index]) return;
      const text = this.voiceContent[index].content;
      navigator.clipboard.writeText(text).then(() => {
        this.$message({
          message: this.$t('aiSpeech.copySuccess'),
          type: 'success'
        });
      }).catch(() => {
        this.$message({
          message: this.$t('aiSpeech.copyFail'),
          type: 'error'
        });
      });
    },
    downloadTxt() {
      const text = this.voiceContent.map(item => `${FormatTime(item.time)} - ${this.behaviorInfo[item.uid]}: ${item.content}`).join('\n');
      const blob = new Blob([text], {
        type: 'text/plain'
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', 'summary.txt'); // 指定下载文件的名称
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    async addEmail(value) {
      if (!value || value.length === 0) return;
      this.showSavingTips = true;
      const params = {
        partyCode: this.partyCode,
        addEmails: value,
        deleteEmails: []
      };
      await this.axios.post('/partyline-backend/stt/transcript/addOrDelEmail', params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.saveEmailSuccess = true;
        }
        setTimeout(() => {
          this.showSavingTips = false;
          this.saveEmailSuccess = false;
        }, 2000);
      });
    },
    deleteEmail(val) {
      const params = {
        partyCode: this.partyCode,
        addEmails: [],
        deleteEmails: [val]
      };
      this.axios.post('/partyline-backend/stt/transcript/addOrDelEmail', params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.$t('aiSpeech.deleteEmailSuccess');
        }
      });
    },
    closeEmail() {
      this.sendEmailInfo.show = false;
    },
    async sendEmail() {
      const hasNotAddEmail = this.emailList.some(item => !item.value);
      if (hasNotAddEmail) {
        const notAddEmailList = this.emailList.filter(item => item.value).map(item => item.value);
        await this.addEmail(notAddEmailList);
      }
      this.axios.post(`/partyline-backend/stt/transcript/sendEmail?partyCode=${this.partyCode}`).then(res => {
        if (res.data.errorCode === '0x0') {
          this.sendEmailInfo.show = false;
          this.$message.success(this.$t('mainWindow.success'));
        }
      });
    }
  }
};